import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import dayjs from 'dayjs'
import { TableTit, TranNum } from './styles'
import useTokenTransferList from '../../../hooks/queries/useTokenTransferList'
import PageLoading from '../../../components/organisms/PageLoading'
import PaginationSingle from '../../../components/molecules/PaginationSingle'
import ContentsWrapper from '../../../components/organisms/ContentsWrapper'
import Table from '../../../components/molecules/Table'
import Button from '../../../components/atoms/Button'
import { roundDownFixedPoint, weiToEther } from '../../../utils/dataFormat'
import Icon from '../../../components/atoms/Icon'
import { getPageParams } from '../../../utils/params'
import usePagination from '../../../hooks/usePagination'

function Transfers() {
  const navigate = useNavigate()
  const { address } = useParams() as { address: string }
  const [currentPage, setCurrentPage] = useState<number>(getPageParams())
  const {
    txs: transactionList = [],
    totalPage = 0,
    totalElements = 0,
    isLoading,
  } = useTokenTransferList(address, currentPage, 20)
  const tokenSymbol = transactionList[0] ? transactionList[0].symbol : ''
  const onClickTxInfo = (type: string, value: string) => {
    navigate(`/${type}/${value}`)
  }
  const { onFirst, onLast, onNext, onPrev } = usePagination({ currentPage, setCurrentPage, totalPage })

  return (
    <>
      <PageLoading loading={isLoading} />
      <TableTit>
        <p>
          A total of <TranNum>{totalElements}</TranNum> transactions
        </p>
      </TableTit>
      <PaginationSingle
        totalPage={totalPage}
        onClickFirstPage={onFirst}
        onClickLastPage={onLast}
        current={currentPage}
        onClickLeft={onPrev}
        onClickRight={onNext}
      />
      <ContentsWrapper>
        <Table
          columns={[
            { title: 'Txn hash', dataIndex: 'txHash', style: { maxWidth: '180px', minWidth: '180px' } },
            { title: 'Method', dataIndex: 'method', style: { maxWidth: '20px', minWidth: '20px' } },
            { title: 'Age', dataIndex: 'blockCreationTime', style: { maxWidth: '90px', minWidth: '90px' } },
            { title: 'From', dataIndex: 'from', style: { maxWidth: '180px', minWidth: '180px' } },
            { title: 'To', dataIndex: 'to', style: { maxWidth: '180px', minWidth: '180px' } },
            { title: 'Value', dataIndex: 'value', style: { maxWidth: '70px', minWidth: '70px' } },
          ]}
          dataSource={transactionList.map((tx) => {
            return {
              ...tx,
              txHash: <Button text={tx.transactionHash} onClick={() => onClickTxInfo('tx', tx.transactionHash)} />,
              blockCreationTime: <>{dayjs.unix(Number(tx.blockTimestamp)).fromNow()} </>,
              from: (
                <>
                  {tx.from.isContract && <Icon name="contractTable" />}
                  <Button text={tx.from.address} onClick={() => onClickTxInfo('account', tx.from.address)} />
                </>
              ),
              to: tx.to && (
                <span>
                  {tx.to?.address === '' ? (
                    <>Unknown</>
                  ) : (
                    <>
                      {tx.to?.isContract && <Icon name="contractTable" />}
                      <Button text={tx.to?.address} onClick={() => onClickTxInfo('account', tx.to?.address ?? '')} />
                    </>
                  )}
                </span>
              ),
              value: (
                <span>
                  {tx.value === '' ? (
                    <>Unknown</>
                  ) : (
                    <>
                      {roundDownFixedPoint(weiToEther(tx.value))} {tokenSymbol}
                    </>
                  )}
                </span>
              ),
            }
          })}
        />
      </ContentsWrapper>
      <PaginationSingle
        totalPage={totalPage}
        onClickFirstPage={onFirst}
        onClickLastPage={onLast}
        current={currentPage}
        onClickLeft={onPrev}
        onClickRight={onNext}
      />
    </>
  )
}

export default Transfers
